module.exports = __webpack_public_path__ + "static/media/C6.07aa9e66.jpg";